import {Box, Grid, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {useI18n} from '@yandex-delivery/core/i18n'
import type {ReactElement} from 'react'

import {Body} from '../../components/desktop'
import {renderWidget} from '../index@desktop'
import type {SectionProps as Props} from '../types'
import {WidgetType} from '../types'
import {groupByDropdownListType, toHeader} from './OffersNDD@desktop.utils'

const root = css`
  margin: ${spacing(1.5, 2, 1)};
`

export function OffersNDDDesktop(props: Props): ReactElement {
  const {headers, content} = groupByDropdownListType(props)
  const i18n = useI18n()

  return (
    <Grid item xs>
      <Paper padding="none" radius="L">
        {headers.map(header => (
          <Grid key={header.widget_id} xs={12} item>
            <Box ml="s" mt="s">
              {renderWidget(toHeader(header))}
            </Box>
            <Grid xs={12} item>
              <div className={root}>
                <Body
                  lead={
                    <Typography mt="s" thickness="medium" variant="body2">
                      {i18n('cargo.create.default_requirements.interval', 'Интервал')}
                    </Typography>
                  }
                  tail={
                    <>
                      {content.map(widget =>
                        renderWidget(
                          widget.type === WidgetType.DROPDOWN_LIST
                            ? {...widget, dataTestId: 'ndd.date_interval_select'}
                            : widget,
                        ),
                      )}
                    </>
                  }
                />
              </div>
            </Grid>
          </Grid>
        ))}
      </Paper>
    </Grid>
  )
}
